import { DataBean } from "../DataBean";

export class AdquisitionItemCDP extends DataBean {

    public async getAdquisitionContractCDPCatalogPorPropiedades(props: any, maxRows: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAdquisitionContractCDPCatalogPorPropiedades_java.util.Map_Number", [props, maxRows]);
    }

    public async getCDPBudgetByDocument(year: number, idAdquisitionItem: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCDPBudgetByDocument_Number_Number", [year, idAdquisitionItem]);
    }

    public async setAdquisitionItemToCDP(idAdquisitionItem: number, idDocument: number, documentDate: any, idEmployee: number, createPdf: boolean): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_setAdquisitionItemToCDP_Number_Number_java.util.Date_Number_Boolean", [idAdquisitionItem, idDocument, documentDate, idEmployee, createPdf]);
    }

}